/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_include_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import Vue from 'vue'
import * as uiv from 'uiv'

import VueShortkey from 'vue-shortkey'
import registerApp from '../helpers/register-app'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueApexCharts from 'vue-apexcharts/dist/vue-apexcharts'
import VueRouter from 'vue-router'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import VueSimplemde from 'vue-simplemde'
import { Swatches } from 'vue-color'
import VueVideoWrapper from 'vue-video-wrapper'
import VModal from 'vue-js-modal'
import 'vue-swipe/dist/vue-swipe.css'
import { Swipe, SwipeItem } from 'vue-swipe';
import PortalVue from 'portal-vue'
// import 'vue-js-modal/dist/styles.css'

Vue.use(Vuetify)
Vue.use(VueRouter)
Vue.use(uiv)
Vue.use(VueShortkey)
Vue.use(VueVideoWrapper)
Vue.use(VModal)
// Vue.component('vue-simplemde', VueSimplemde)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('apexchart', VueApexCharts)
Vue.component('swatches', Swatches)
Vue.component('swipe', Swipe);
Vue.component('swipe-item', SwipeItem);
Vue.use(PortalVue)
import EditorApp from '../apps/editor'
import SchoolDesignPreview from '../apps/school-design-preview'
import ExamApp from '../apps/exam'
import ImportApp from '../apps/import'
import ClientApp from '../apps/client'
import ExamCreationFromStock from '../apps/exam_from_stock'
import ClientEmbed from '../apps/embed'

(window as any).load_frontend = ()=> {
  registerApp(EditorApp)
  registerApp(SchoolDesignPreview)
  registerApp(ExamApp)
  registerApp(ImportApp)
  registerApp(ClientApp)
  registerApp(ClientEmbed)
  registerApp(ExamCreationFromStock)
}